import { NgModule, APP_INITIALIZER,ModuleWithProviders } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import {
  MatPaginatorIntl,
  MatDialogModule,
  MatSnackBarModule,
  MAT_DATE_LOCALE,
} from '@angular/material';
import { TemaService } from './providers/tema.service';
import { Globals } from './globals';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AuthenticationService } from './providers/auth.service';
import {
  BaseRequestOptions,
  HttpModule
} from '@angular/http';
import {
  HttpClientModule
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpInterceptor } from './interceptors/http-interceptor.service';
import { PermisoService } from './providers/permiso.service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { GeneralService } from './providers/general.service';
import { ReloginModule } from './pages/public/relogin/relogin.module';
import { ConfiguracionEmpresaService } from './providers/configuracion-empresa.service';
import { HelpComponent } from './components/help/help.component';
import { VerIncidenciaComponent } from './components/incidencia/ver-incidencia/ver-incidencia.component';
import { OAuthModule } from 'angular-oauth2-oidc';

// Esta funcion levanta primero en _env.json y despues inicia la APP ,
export function initConfig(_generalSv: GeneralService) {
  return () => _generalSv.getGeneralesLocal();
}
@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    NgxPermissionsModule.forRoot(),
    HttpClientModule,
    HttpModule,
    MatDialogModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatMomentDateModule,
    ReloginModule,
    OAuthModule.forRoot(),
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    GeneralService,
    MatPaginatorIntl,
    TemaService,
    Globals,
    AuthenticationService,
    BaseRequestOptions,
    HttpInterceptor,
    PermisoService,
    // ConfiguracionEmpresaService,
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es'
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [GeneralService],
      multi: true,
    },
  ],
  entryComponents: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
